<template>
    <div class="container-card-exlucive-units">
        <section class="title">
            <ui-square-th-one />
            <span>Gestão Exclusiva</span>
        </section>

        <section class="activate-exclusive-units" >
            <ui-switch
                data-ui="activate-exclusive-units"
                design="xs"
                v-model="configActiveModel"
                :checked="configActiveModel"
                :disabled="loading.loadFixed"
                @input="handleActivateExclusiveUnits('has_config_active')"
            />

            <span class="activate-exclusive-units-text">
                Ativar o recurso de <b>unidades exclusivas</b> para o empreendimento.
            </span>

            <div v-if="loading.loadFixed" class="loading-card-fixed">
                <ui-load-indicator bgColor="#e7e9f4" color="#3FACFF" :h="20" :stroke="6" />
            </div>
        </section>

        <transition name="small-fade">
            <div v-if="loading.loadFixed " class="loading-card">
                <ui-load-indicator bgColor="#e7e9f4" color="#3FACFF" :h="50" :stroke="8" />
            </div>
        </transition>

        <section v-if="!loading.load && configActiveModel" class="table-activate-excluve-units" >
            <div class="actions-filter">
                <ui-select-v2
                    v-model="form.data.block"
                    :data="blocksOptions"
                    :label="availabilityType == 'horizontal' ? 'Quadra' : 'Torre'"
                    placeholder="Selecione"
                    return-value="value"
                    design="mgb-15 mw-100"
                    :disabled="loading.loadingTable"
                    @input="applyFilters"
                />

                <ui-select-v2
                    v-if="availabilityType == 'vertical'"
                    v-model="form.data.floor"
                    :data="floorsOptions"
                    label="Andar:"
                    placeholder="Selecione"
                    return-value="value"
                    design="mgb-15 mw-100"
                    :disabled="loading.loadingTable"
                    @input="applyFilters"
                />

                <ui-select-v2
                    v-model="form.data.situation"
                    :data="situationsOptions"
                    label="Status:"
                    placeholder="Selecione"
                    return-value="value"
                    design="mgb-15 mw-100"
                    :disabled="loading.loadingTable"
                    @input="applyFilters"
                />

                <ui-select-v2
                    v-model="form.data.team"
                    :data="teamsOptions"
                    label="Equipe:"
                    placeholder="Selecione"
                    return-value="id"
                    design="mgb-15 mw-100"
                    :disabled="loading.loadingTable"
                    @input="applyFilters"
                />

                <div class="others-config">
                    <span class="others-config-text">
                        Outras configurações
                    </span>

                    <ui-menu-card icon="fal fa-cog" :icon-size="18" :disabled="loading.loadingTable">
                        <span class="menu-others-config">
                            Outras configurações
                        </span>

                        <div v-if="loading.unitsValue " class="loading-units-value">
                            <ui-load-indicator bgColor="#e7e9f4" color="#3FACFF" :h="20" :stroke="6" />
                        </div>

                        <div class="active-teams-visualize-units">
                            <ui-switch
                                data-ui="activate-exclusive-units"
                                design="xs primary mgb-0"
                                v-model="hasViewUnitsModel"
                                :checked="hasViewUnitsModel"
                                @input="handleActivateExclusiveUnits('has_view_units')"
                            />

                            <span class="active-teams-visualize-units-text">Permitir que equipes visualizem unidades de outras equipes.</span>
                        </div>

                        <div class="active-teams-visualize-value">
                            <ui-switch
                                data-ui="activate-exclusive-value"
                                design="xs primary mgb-0"
                                v-model="hasViewValueModel"
                                :checked="hasViewValueModel"
                                @input="handleActivateExclusiveUnits('has_view_value')"
                            />

                            <span class="active-teams-visualize-value-text">Permitir que equipes visualizem valores de unidades de outras equipes.</span>
                        </div>
                    </ui-menu-card>
                </div>
            </div>

            <div v-if="!loading.load" class="content-table">
                <ui-table
                    name="exclusive"
                    tr-component="products/permissions/exclusive-units/exclusive-units-table-line"
                    not-found-text="Não foi possível encontrar nenhuma unidade"
                    not-found-icon="fal fa-building"
                    selectable
                    line-white
                    check-padding-left="20px"
                    :per-page="perPage"
                    :sort-by="tableParams.sortBy"
                    :loading="loading.loadingTable"
                    :columns="tableColumns"
                    :last-col-fixed="false"
                    :select-column-menu="false"
                    :is-fixed-list="false"
                    :data="tableData"
                    :all-selected="disableAllSelected"
                    @select-all="selectedAll"
                    @sort="load({}, 'sort')"
                />
                <div style="margin-top: 10px">
                    <ui-pagination
                    v-if="pagination.current_page <= pagination.last_page"
                    :pages="lastPageComputed"
                    :current="currentPageComputed"
                    @previous="previousPageHandler"
                    @next="nextPageHandler"
                />
                </div>
            </div>
        </section>

        <ui-new-teams-modal :params="paramsModal" />
    </div>
</template>

<script>
import { uiLoadIndicator, uiMenuCard, uiPagination, uiTable } from '@/components/ui/'
import { uiSelectV2, uiSwitch } from '@/components/ui/form'
import { alertMixin } from '@/mixins'
import { mapActions, mapGetters } from 'vuex'
import uiNewTeamsModal from '../new-teams-modal'

const defaultLoading = function () {
    return {
        load: false,
        loadFixed: false,
        loadingTable: false,
        unitsValue: false
    }
}

export default {
    name: 'ui-exclusive-units-card',

    components: {
        uiSelectV2,
        uiSwitch,
        uiMenuCard,
        uiTable,
        uiLoadIndicator,
        uiNewTeamsModal,
        uiPagination
    },

    props: {},

    mixins: [
        alertMixin
    ],

    data() {
        return {
            configActiveModel: false,
            loading: { ...defaultLoading() },
            product_id: null,
            form: {
                data: {
                    block: null,
                    floor: null,
                    stage: null,
                    situation: null,
                    team: null
                }
            },
            hasViewUnitsModel: false,
            hasViewValueModel: false,
            paramsModal: {},
            tableData: [],
            disableAllSelected: false,
            perPage: 25,
            lastFilters: {},
        }
    },

    async mounted() {
        this.product_id = this.$route.params.id
        this.loading.loadFixed = true
        this.handleSetLoadingList(true)
        await this.load().then().finally(() => {
            this.loading.loadFixed = false
            this.handleSetLoadingList(false)
        })

        this.tableData = this.getData?.availability?.units
        this.hasViewUnitsModel = this.getData?.config?.has_view_units
        this.hasViewValueModel = this.getData?.config?.has_view_value

        this.$root.$on('selected-all-checked', checked => {
            this.handleSelectedUnitsChecked(checked)
        })

        this.paramsModal = {
            type: "units_teams",
            active: this.configActiveModel,
            product_id: Number(this.product_id),
            configurations: {
                has_view_units: this.hasViewUnitsModel,
                has_view_value: this.hasViewValueModel,
                units: [],
                teams: []
            }
        }

        this.$root.$on('modal-msg-close-new-teams-modal', () => {
            this.updateTableData()
        })

        this.$root.$on('select-all-disabled', bool => {
            if (bool == false) return
            this.disableAllSelected = bool
        })
    },

    computed: {
        ...mapGetters('exclusiveManagement', [
            'getData',
            'getConfigLimit'
        ]),

        ...mapGetters({
            tableParams: 'table/getParams',
        }),

        availabilityType() {
            return this.getData?.availability?.type
        },

        pagination() {
            return this.getData?.pagination
        },

        lastPageComputed() {
            return this.pagination && this.pagination.last_page ? this.pagination.last_page : 0
        },

        currentPageComputed() {
            return this.pagination && this.pagination.current_page ? this.pagination.current_page : 0
        },

        tableColumns() {
            let columns = [
                {
                    title: `${this.availabilityType == 'horizontal' ? 'Quadra' : 'Torre'}`,
                    sortable: true,
                    data: 'block'
                },
                {
                    title: `${this.availabilityType == 'horizontal' ? 'Lote' : 'Unidade'}`,
                    sortable: true,
                    data: 'number'
                }
            ]

            if (this.availabilityType === 'vertical') {
                columns.push({
                    title: 'Andar',
                    sortable: true,
                    data: 'floor'
                })
            }

            columns.push(
                {
                    title: 'Metragem',
                    sortable: true,
                    data: 'area'
                },
                {
                    title: 'Valor',
                    sortable: true,
                    data: 'cost'
                },
                {
                    title: 'Status',
                    sortable: true,
                    data: 'situation'

                },
                { title: 'Equipes Autorizadas' },
                { title: '' }
            )

            return columns
        },

        configActive() {
            return this.getData?.config?.active
        },

        filters() {
            return this.getData?.filters
        },

        blocksOptions() {
            return this.filters?.blocks?.map(value => ({ label: `${this.availabilityType == 'horizontal' ? 'Quadra' : 'Torre'} ${value}`, value }))
        },

        floorsOptions() {
            return this.filters?.floors?.map(value => ({ label: `Andar ${value}`, value }))
        },

        stagesOptions() {
            return this.filters?.stages?.map(value => ({ label: `Etapa ${value}`, value }))
        },

        situationsOptions() {
            const labels = {
                available: "Disponível",
                "pre-reserve": "Pré-reserva",
                reserved: "Reservado",
                "reserved-permanetly": "Reservado Permanentemente",
                sale: "Vendido"
            }
            return this.filters?.situations.map(value => ({ label: labels[value] || value, value }))
        },

        teamsOptions() {
            return this.filters.teams.map(team => ({
                label: team.name,
                id: team.id
            }))
        },

        configLimitData() {
            return this.getConfigLimit?.data
        },

        configLimitMsg() {
            return this.getConfigLimit?.msg
        }
    },

    watch: {
        getData() {
            this.tableData = this.getData?.availability?.units
        },

        disableAllSelected() {
            this.disableAllSelected = false
        },
        configActiveModel: {
            immediate: true,
            handler(newValue) {
                if(!newValue){
                    this.handleHasSummary(false)
                } 
            }
        },
    },

    methods: {
        ...mapActions('exclusiveManagement', [
            'listExclusiveUnits',
            'activateExclusiveUnits',
            'handleSelectedUnitsChecked',
            'handleHasSummary',
            'handleSetLoadingList',
            'updateConfigActiveData'
        ]),

        getTeamsByIds(teamsIds) {
            const allTeams = this.teamsOptions || []
            return allTeams.filter(team => teamsIds.includes(team.id))
        },

        updateTableData() {
            if (!this.configLimitData?.value?.units_exclusives) return

            const unitsMap = this.configLimitData.value.units_exclusives.reduce((map, unit) => {
                map[unit.unity_id] = unit.teams_id
                return map
            }, {})

            this.tableData = this.tableData.map(unit => ({
                ...unit,
                teams: unit.id in unitsMap
                    ? this.getTeamsByIds(unitsMap[unit.id])
                    : []
            }))
        },

        async load(filters = {}, type, nextPage = 1) {
            this.loading.loadingTable = true;


            let params = {
                id: this.product_id,
                query: {
                    type: 'units-teams',
                    header: true,
                    filter: `orderby:${this.tableParams?.sortBy?.value},order:${this.tableParams?.sortBy?.dir},page:${nextPage},per_page:${this.perPage}`,
                }
            }

            if (filters) {
                Object.keys(filters).forEach(key => {
                    if (filters[key]) {
                        params.query.filter += `,${key}:${filters[key]}`
                    }
                })
            }
            await this.listExclusiveUnits(params)
                .then(() => {
                    this.configActiveModel = this.configActive
                })
                .catch(error => {
                    if (error.data?.msg) {
                        this.$mx_alertError(error.data.msg)
                    }
                }).finally(() => {
                    this.loading.load = false
                    this.loading.loadFixed = false
                    this.loading.loadingTable = false
                    this.loading.unitsValue = false
                    this.handleSetLoadingList(false)
                    if(this.configActiveModel) this.handleHasSummary(true)
                })
        },

        async handleActivateExclusiveUnits(type) {
            this.loading.unitsValue = true
            this.loading.loadingTable = true
            if(type == 'has_config_active'){
                this.loading.loadFixed = true
            }


            let params = {
                type: "units_teams",
                active: this.configActiveModel,
                product_id: Number(this.product_id),
                configurations: {
                    has_view_units: this.hasViewUnitsModel,
                    has_view_value: this.hasViewValueModel
                }
            }

            try {
                if (this.configActiveModel && type === 'has_config_active') {
                    this.loading.load = true
                    await this.activateExclusiveUnits(params)
                    await this.load().then().finally(() => {
                        this.loading.load = false
                        this.loading.loadFixed = false
                        this.handleSetLoadingList(false)
                        this.loading.unitsValue = false
                        this.loading.loadingTable = false
                        this.updateConfigActiveData(params.configurations)
                    })
                } else await this.activateExclusiveUnits(params).finally(() => {
                        this.loading.load = false
                        this.loading.loadFixed = false
                        this.handleSetLoadingList(false)
                        this.loading.unitsValue = false
                        this.loading.loadingTable = false
                        this.updateConfigActiveData(params.configurations)
                    })
            } catch (error) {
                if (error.data?.msg) {
                    this.$mx_alertError(error.data.msg)
                }
            } 
        },

        selectedAll(bool) {
            this.$root.$emit('select-all-exclusive-units', bool)
        },

        async applyFilters() {
            const filters = {
                blocks: this.form.data.block,
                floors: this.form.data.floor,
                situations: this.form.data.situation,
                teams: this.form.data.team
            }

            if (JSON.stringify(filters) !== JSON.stringify(this.lastFilters)) {
                this.lastFilters = { ...filters }
                await this.load(filters, 'sort')
            }
        },


        async previousPageHandler() {
           await this.load({...this.lastFilters}, '', Number(this.pagination.current_page) - 1)
        },

        async nextPageHandler() {
          await  this.load({...this.lastFilters}, '', Number(this.pagination.current_page) + 1)
        },
    }
}
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>
